import { z } from 'zod';
/**
 * "When I can't answer": what happens to calls for a person's own number.
 * Their devices ring, then (if they choose) their mobile, then the call goes
 * to `unanswered`: their voicemail, a colleague, or a queue. While they are
 * away (dates), and on a call if they choose, it goes there straight away.
 */
export const unansweredTargets = ['VOICEMAIL', 'COLLEAGUE', 'QUEUE'];
export const unansweredTargetNames = {
    VOICEMAIL: 'My voicemail',
    COLLEAGUE: 'A colleague',
    QUEUE: 'A queue',
};
const day = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Choose a date');
export const callRulesSchema = z
    .object({
    ringMobile: z.boolean(),
    forwardWhenBusy: z.boolean(),
    unanswered: z.enum(unansweredTargets),
    unansweredUserId: z.uuid().nullable(),
    unansweredQueueId: z.uuid().nullable(),
    /** Days in the person's time zone, both included. From null: from now. */
    awayFrom: day.nullable(),
    awayUntil: day.nullable(),
})
    .superRefine((rules, ctx) => {
    if (rules.unanswered === 'COLLEAGUE' && !rules.unansweredUserId)
        ctx.addIssue({ code: 'custom', path: ['unansweredUserId'], message: 'Choose a colleague' });
    if (rules.unanswered === 'QUEUE' && !rules.unansweredQueueId)
        ctx.addIssue({ code: 'custom', path: ['unansweredQueueId'], message: 'Choose a queue' });
    if (rules.awayFrom && !rules.awayUntil)
        ctx.addIssue({ code: 'custom', path: ['awayUntil'], message: 'Choose the last day' });
    if (rules.awayFrom && rules.awayUntil && rules.awayUntil < rules.awayFrom) {
        ctx.addIssue({ code: 'custom', path: ['awayUntil'], message: 'The last day is before the first' });
    }
});
/** Away right now: inside the dates (from null: already started). */
export function awayAt(person, at) {
    return person.awayUntil !== null && at < person.awayUntil && (person.awayFrom === null || person.awayFrom <= at);
}
export const maxGreetingBytes = 5 * 1024 * 1024;
